import 'angular-bootstrap-colorpicker';

import propertyRoutes from './property.routes';

import propertySaveController from './controllers/property.save.controller';
import propertyGroupSaveController from './controllers/property.group.save.controller';
import propertyFormController from './controllers/property.form.controller';
import propertyBrandFormController from './controllers/property.brand.form.controller';
import propertyGroupFormController from './controllers/property.group.form.controller';
import propertyListController from './controllers/property.list.controller';
import propertyGroupListController from './controllers/property.group.list.controller';
import propertyIntegrationFormController from './controllers/property.integration.form.controller';
import propertyDetailsController from './controllers/property.details.controller';
import propertySelectorController from './controllers/property.selector.controller';
import propertiesSelectController from './controllers/properties.select.controller';
import propertySingleSelectController from './controllers/property.single.select.controller';
import propertySelectController from './controllers/property.select.controller';
import propertyFinanceController from './controllers/property.finance.controller';
import paymentConnectController from './controllers/payment.connect.controller';

import propertyListComponent from './components/property.list.component';
import propertyGroupListComponent from './components/property.group.list.component';
import propertyFormComponent from './components/property.form.component';
import propertySettingsComponent from './components/property.settings.component';
import propertyStyleComponent from './components/property.style.component';
import propertyBrandFormComponent from './components/property.brand.form.component';
import propertyFinanceFormComponent from './components/property.finance.form.component';
import propertyIntegrationFormComponent from './components/property.integration.form.component';
import propertyGroupFormComponent from './components/property.group.form.component';
import propertyBusinessComponent from './components/property.business.component';
import propertySocialComponent from './components/property.social.component';
import propertyContactComponent from './components/property.contact.component';
import propertySaveComponent from './components/property.save.component';
import propertyGroupSaveComponent from './components/property.group.save.component';
import propertySelectorComponent from './components/property.selector.component';
import propertiesSelectComponent from './components/properties.select.component';
import propertySingleSelectComponent from './components/property.single.select.component';
import propertySelectComponent from './components/property.select.component';
import paymentConnectComponent from './components/payment.connect.component';

import propertiesService from './services/properties.service';
import integrationApiService from './services/integration.api.service';
import integrationService from './services/integration.service';
import propertiesFinanceService from './services/properties.finance.service';
import propertyGroupService from './services/property.group.service';
import propertyLoadService from './services/property.load.service';
import propertyService from './services/property.service';

let propertyModule = angular.module('spabooker.property', ['spabooker.base', 'colorpicker.module'])
    .config(propertyRoutes)

    .controller('propertySaveController', propertySaveController)
    .controller('propertyGroupSaveController', propertyGroupSaveController)
    .controller('propertyFormController', propertyFormController)
    .controller('propertyBrandFormController', propertyBrandFormController)
    .controller('propertyGroupFormController', propertyGroupFormController)
    .controller('propertyDetailsController', propertyDetailsController)
    .controller('propertyListController', propertyListController)
    .controller('propertyGroupListController', propertyGroupListController)
    .controller('propertyIntegrationFormController', propertyIntegrationFormController)
    .controller('propertySelectorController', propertySelectorController)
    .controller('propertiesSelectController', propertiesSelectController)
    .controller('propertySingleSelectController', propertySingleSelectController)
    .controller('propertySelectController', propertySelectController)
    .controller('propertyFinanceController', propertyFinanceController)
    .controller('paymentConnectController', paymentConnectController)

    .component('propertyList', propertyListComponent)
    .component('propertyGroupList', propertyGroupListComponent)
    .component('propertyForm', propertyFormComponent)
    .component('propertySettings', propertySettingsComponent)
    .component('propertyStyle', propertyStyleComponent)
    .component('propertyBrandForm', propertyBrandFormComponent)
    .component('propertyIntegrationForm', propertyIntegrationFormComponent)
    .component('propertyBusiness', propertyBusinessComponent)
    .component('propertySocial', propertySocialComponent)
    .component('propertyContact', propertyContactComponent)
    .component('propertyFinanceForm', propertyFinanceFormComponent)
    .component('propertyGroupForm', propertyGroupFormComponent)
    .component('propertySave', propertySaveComponent)
    .component('propertyGroupSave', propertyGroupSaveComponent)
    .component('propertySelector', propertySelectorComponent)
    .component('propertiesSelect', propertiesSelectComponent)
    .component('propertySingleSelect', propertySingleSelectComponent)
    .component('propertySelect', propertySelectComponent)
    .component('paymentConnect', paymentConnectComponent)

    .factory('propertiesService', propertiesService)
    .factory('integrationApiService', integrationApiService)
    .factory('integrationService', integrationService)
    .factory('propertiesFinanceService', propertiesFinanceService)
    .factory('propertyGroupService', propertyGroupService)
    .factory('properties', propertyLoadService)
    .factory('propertyService', propertyService)
    ;

export default propertyModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/index.js